import { useEffect, useRef } from 'react'

// Brand-blue sparks on every click (after React Bits' ClickSpark), drawn on one fixed canvas.
export default function ClickSpark({ count = 10, radius = 28, size = 12, duration = 520 }) {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')
    const dpr = Math.min(window.devicePixelRatio, 2)
    const palette = ['#2D5CFF', '#7D9BFF', '#2D85D6', '#FFFFFF']
    let sparks = []
    let raf = 0
    let w = window.innerWidth
    let h = window.innerHeight

    const resize = () => {
      w = window.innerWidth
      h = window.innerHeight
      canvas.width = w * dpr
      canvas.height = h * dpr
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    }
    resize()
    window.addEventListener('resize', resize)

    const draw = (now) => {
      ctx.clearRect(0, 0, w, h)
      sparks = sparks.filter((s) => {
        const t = (now - s.start) / duration
        if (t >= 1) return false
        const e = 1 - Math.pow(1 - t, 3)
        const dist = e * radius
        const len = size * (1 - e)
        const cos = Math.cos(s.angle)
        const sin = Math.sin(s.angle)
        ctx.strokeStyle = s.color
        ctx.lineWidth = 2
        ctx.lineCap = 'round'
        ctx.beginPath()
        ctx.moveTo(s.x + dist * cos, s.y + dist * sin)
        ctx.lineTo(s.x + (dist + len) * cos, s.y + (dist + len) * sin)
        ctx.stroke()
        return true
      })
      raf = sparks.length ? requestAnimationFrame(draw) : 0
    }

    const click = (e) => {
      const now = performance.now()
      for (let i = 0; i < count; i++) {
        sparks.push({
          x: e.clientX,
          y: e.clientY,
          angle: (2 * Math.PI * i) / count + Math.random() * 0.25,
          start: now,
          color: palette[i % palette.length],
        })
      }
      if (!raf) raf = requestAnimationFrame(draw)
    }
    window.addEventListener('click', click)
    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener('resize', resize)
      window.removeEventListener('click', click)
    }
  }, [count, radius, size, duration])

  return <canvas ref={canvasRef} aria-hidden className="pointer-events-none fixed inset-0 z-[399] h-full w-full" />
}
